import { render, staticRenderFns } from "./notsupport.vue?vue&type=template&id=296968f6"
import script from "./notsupport.vue?vue&type=script&lang=js"
export * from "./notsupport.vue?vue&type=script&lang=js"
import style0 from "./notsupport.vue?vue&type=style&index=0&id=296968f6&prod&lang=stylus&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports